import { type ReactNode, useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import DoduThemeIndex from "../theme/dodu/doduThemeIndex"
import themeBg from "../theme/dodu/assets/theme_bg.png"
import watchBg from "../watch/dodu/assets/watch_bg.png"
import DoduWatchIndex from "../watch/dodu/doduWatchIndex"

interface SharedLayoutPage {
    path: string
    component: ReactNode
    backgroundImage?: string
    overflowVisible?: boolean
}

const pages: SharedLayoutPage[] = [
    {
        path: "/showcase/theme/dodu",
        component: <DoduThemeIndex />,
        backgroundImage: themeBg,
    },
    {
        path: "/showcase/watch/dodu",
        component: <DoduWatchIndex />,
        backgroundImage: watchBg
        // overflowVisible: true,
    },
]

const SharedDoduLayout = () => {
    const rootRef = useRef<HTMLDivElement>(null)
    const location = useLocation()
    const activePage = pages.find((page) => page.path === location.pathname)

    // ios 좌우 스크롤 시 상하단 이동 방지
    useEffect(() => {
        const root = rootRef.current
        const html = document.documentElement
        const body = document.body
        const previousHtmlOverflow = html.style.overflow
        const previousHtmlOverscrollBehavior = html.style.overscrollBehavior
        const previousBodyOverflow = body.style.overflow
        const previousBodyPosition = body.style.position
        const previousBodyWidth = body.style.width
        const previousBodyHeight = body.style.height
        const previousBodyTouchAction = body.style.touchAction

        html.style.overflow = "hidden"
        html.style.overscrollBehavior = "none"
        body.style.overflow = "hidden"
        body.style.position = "fixed"
        body.style.width = "100%"
        body.style.height = "100%"
        body.style.touchAction = "none"

        let startX = 0
        let startY = 0

        const handleTouchStart = (event: TouchEvent) => {
            const touch = event.touches[0]

            if (!touch) {
                return
            }

            startX = touch.clientX
            startY = touch.clientY
        }

        const handleTouchMove = (event: TouchEvent) => {
            const touch = event.touches[0]

            if (!touch) {
                return
            }

            const deltaX = touch.clientX - startX
            const deltaY = touch.clientY - startY

            if (Math.abs(deltaY) > Math.abs(deltaX)) {
                event.preventDefault()
            }
        }

        root?.addEventListener("touchstart", handleTouchStart, { passive: true })
        root?.addEventListener("touchmove", handleTouchMove, { passive: false })

        return () => {
            root?.removeEventListener("touchstart", handleTouchStart)
            root?.removeEventListener("touchmove", handleTouchMove)
            html.style.overflow = previousHtmlOverflow
            html.style.overscrollBehavior = previousHtmlOverscrollBehavior
            body.style.overflow = previousBodyOverflow
            body.style.position = previousBodyPosition
            body.style.width = previousBodyWidth
            body.style.height = previousBodyHeight
            body.style.touchAction = previousBodyTouchAction
        }
    }, [])

    return (
        <div
            ref={rootRef}
            className={`relative mx-auto h-full w-full max-w-[600px] min-w-0 overscroll-none 
                        ${activePage?.overflowVisible ? "overflow-visible" : "overflow-hidden"} md:max-w-[800px]`
            }
        >
            <div className="absolute inset-0 overflow-hidden">
                <img
                    src={activePage?.backgroundImage ?? ""}
                    className="object-cover"
                    alt=""
                />
            </div>

            <div className="relative z-10 grid h-full grid-rows-[1fr_2.7fr] sm:grid-rows-[1fr_1.3fr]">
                <div />
                <div className="min-h-0">
                    {activePage?.component ?? null}
                </div>
            </div>
        </div>
    )
}

export default SharedDoduLayout
